import React from "react";
import { Box } from "@mui/material";
import { QuestionCard } from "../shared/QuestionCard";
import { QuizChoiceCard, ChoiceOption } from "../form/QuizChoiceCard";
import { StyledTextField } from "../form/StyledTextField";
import { CurrentFood, CURRENT_FOOD_LABEL } from "@/helpers/enums";
import { quizAsset } from "../shared/quizAssets";

type Props = {
  dogName: string;
  value: string[];
  brand?: string;
  onChange: (foods: string[], brand?: string) => void;
};

/** Issue #52 A1 - what the dog eats today, with the designed food-type icons.
 *  The brand is captured for a later personalised cost comparison and gates
 *  the "tried fresh" branch. */
const OPTIONS: ChoiceOption[] = [
  { value: CurrentFood.DRY, label: CURRENT_FOOD_LABEL[CurrentFood.DRY], icon: quizAsset("icon-food-dry") },
  { value: CurrentFood.WET, label: CURRENT_FOOD_LABEL[CurrentFood.WET], icon: quizAsset("icon-food-wet") },
  { value: CurrentFood.RAW, label: CURRENT_FOOD_LABEL[CurrentFood.RAW], icon: quizAsset("icon-food-raw") },
  { value: CurrentFood.HOME_COOKED, label: CURRENT_FOOD_LABEL[CurrentFood.HOME_COOKED], icon: quizAsset("icon-food-homecooked") },
  { value: CurrentFood.FRESH, label: CURRENT_FOOD_LABEL[CurrentFood.FRESH], icon: quizAsset("icon-food-fresh") },
];

export function CurrentFoodQuestion({ dogName, value, brand = "", onChange }: Props) {
  const toggle = (food: string) => {
    const next = value.includes(food)
      ? value.filter((f) => f !== food)
      : [...value, food];
    onChange(next, brand);
  };

  return (
    <QuestionCard
      title={`What does ${dogName || "your dog"} eat at the moment?`}
      subtitle="Select all that apply"
      subtitleAbove
    >
      <QuizChoiceCard
        options={OPTIONS}
        selected={value}
        onSelect={toggle}
        multiple
        size="sm"
      />

      {value.length > 0 && (
        <Box sx={{ mt: 2, width: "100%", maxWidth: 380, mx: "auto" }}>
          <StyledTextField
            fullWidth
            placeholder="Mainly from... (brand, optional)"
            value={brand}
            onChange={(e) => onChange(value, e.target.value)}
            autoComplete="off"
            inputProps={{ autoComplete: "off" }}
          />
        </Box>
      )}
    </QuestionCard>
  );
}
